module.exports = __webpack_public_path__ + "static/media/mention-bro-internet.f9a006c8.svg";